import React from 'react'
import useWindowSize from '../hooks/useWindowSize';

// Asset URLs from Figma


const NewLogo = () => {

  const { width } = useWindowSize()
  return (
    <div className="pt-4 mx-auto md:max-w-[358px] w-full flex flex-col items-center gap-2">
    <div className='w-fit bg-white/10 flex items-center p-2 rounded-md gap-2'>
        <img src="https://assets.learntube.ai/files/new%20Linkedin%20data/image%2011.png?updatedAt=1747309992449" loading="eager" alt="" width={24} height={24} className='w-6 h-6' />
        <p className='font-medium text-xs text-white'>LearnTube.ai</p>
    </div>
    <div
        className={`w-[calc(100%+2rem)] justify-center ${width < 360 ? 'gap-4' : 'gap-6'} pt-2 pb-2.5 px-6 flex sm:rounded shadow-[0_4px_8px_-4px_rgba(0,0,0,0.5)]`}
        style={{
            backgroundImage: 'linear-gradient(to top, rgba(64, 106, 255, 0.1) 25%, rgba(2, 36, 57, 0.1) 100%)'
        }}
    >
        <div className="flex-1 flex flex-col items-center gap-1">
            <h4 className="text-[0.5625rem] text-white/50 leading-none">Recognised by</h4>
            <img src="https://assets.learntube.ai/files/company-logos/Logosvg.webp" width={69} height={14} className="flex-shrink-0 w-auto h-[0.875rem]" alt="" />
        </div>
        <div className="self-stretch w-[1px] bg-white/20" />
        <div className="flex-1 flex flex-col items-center gap-1">
            <h4 className="text-[0.5625rem] text-white/50 leading-none">backed by</h4>
            <img src="https://assets.learntube.ai/files/company-logos/Frame%20427323186.webp" width={69} height={14} className="flex-shrink-0 w-auto h-[0.875rem]" alt="" />
        </div>
        <div className="self-stretch w-[1px] bg-white/20" />
        <div className="flex-1 flex items-center gap-1">
            <img src="https://assets.learntube.ai/files/company-logos/Frame%20427323188.webp" width={85} height={23} className="flex-shrink-0 w-auto h-[1.4375rem]" alt="" />
        </div>
    </div>
</div>
  )
}

export default NewLogo